import WPColumns from './wp-columns';
import ProjectHighlights from '../project-highlight';
import WpGroup from './wp-group';
import WpHeading from './wp-heading';
import WpGallery from './wp-gallery';
import WpYoutubeVideo from './wp-video';
import WpLazyBlockLightBoxImage from './wp-lazyblock-lightbox-image';
import WpDefaultHtml from './wp-default-html';
import { WPBlockProps } from './types';
import WpImage from './wp-image';

export function getWpBlock(
  typeName: string,
): (props: WPBlockProps) => JSX.Element | null {
  switch (typeName) {
    case 'WpCoreColumnsBlock':
      return WPColumns;
    case 'WpCoreGroupBlock':
      return WpGroup;
    case 'WpLazyblockProjectHighlightBlock':
      return ProjectHighlights;
    case 'WpCoreHeadingBlock':
      return WpHeading;
    case 'WpCoreImageBlock':
      return WpImage;
    case 'WpCoreGalleryBlock':
      return WpGallery;
    case 'WpCoreEmbedYoutubeBlock':
      return WpYoutubeVideo;
    case 'WpLazyblockLightboxImageBlock':
      return WpLazyBlockLightBoxImage;
    default:
      return WpDefaultHtml;
  }
}

export default {
  WpColumnsBlock: WPColumns,
  WpGroup,
  WpHeading,
  WpGallery,
  WpYoutubeVideo,
  WpLazyBlockLightBoxImage,
};
